import axios from 'axios'
import { host } from '../../helper/config'

const PLUGIN_NAME = 'admin-whitelist-ip'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  Authorization: token,
})

async function post(token, path, body = {}) {
  try {
    const response = await axios.post(`${host}/${PLUGIN_NAME}/${path}`, body, {
      headers: headers(token),
    })
    if (response && response.status === 200) {
      return { ok: true, data: response.data }
    }
    return { ok: false, message: 'Request failed' }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Có lỗi xảy ra'
    return { ok: false, message }
  }
}

export const getAllWhitelistIps = async (token) => {
  const result = await post(token, 'get-all')
  if (result.ok) {
    return result.data || {}
  }
  return { error: true, message: result.message }
}

export const addWhitelistIp = async (token, payload) => {
  const result = await post(token, 'add', payload)
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const updateWhitelistIp = async (token, payload) => {
  const result = await post(token, 'update', payload)
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}

export const deleteWhitelistIp = async (token, ip) => {
  const result = await post(token, 'delete', { ip })
  if (result.ok) {
    return result.data
  }
  return { error: true, message: result.message }
}
